export const primaryColor = "#004457";
export const lightPrimaryColor = "#326978";
export const secondaryColor = "#ec622d";
// export const secondaryColor = "#DAA520";
export const lightSecondaryColor = "#F18876";